/**
 * MapObjectDetailsService
 *
 * Reads the contact facts a map object's popover shows - name, address,
 * phone, email, website - for one Lead or Customer by its own id. A Place is
 * only a point, so the facts come from the business record standing on it
 * (/api/map-objects, permission-checked per feature on the server).
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

/** The facts the server returns for one map object. */
export interface MapObjectDetails {
  readonly name?: string | null;
  readonly address?: string | null;
  readonly phone?: string | null;
  readonly email?: string | null;
  readonly website?: string | null;
}

@Injectable({ providedIn: 'root' })
export class MapObjectDetailsService {
  constructor(private readonly http: HttpClient) { }

  /** One Lead or Customer's popover facts; another feature has none. */
  get(featureKey: string, id: number): Observable<MapObjectDetails> {
    switch (featureKey) {
      case 'leads':
        return this.http.get<MapObjectDetails>(`/api/map-objects/leads/${id}`);
      case 'customers':
        return this.http.get<MapObjectDetails>(`/api/map-objects/customers/${id}`);
      default:
        return throwError(() => new Error(`No map object details for ${featureKey}.`));
    }
  }
}
